import {
  PescatarianIcon,
  SpicyIcon,
  VeganIcon,
  VegetarianIcon,
  ChefRecoIcon,
} from '../icons';
import {
  Tooltip,
  TooltipTrigger,
  TooltipContent,
  TooltipProvider,
} from '@/components/ui/tooltip';

type DietIcon = React.ComponentType<{ className?: string; 'aria-label'?: string; 'aria-hidden'?: boolean }>;

const dietTagIcons: Record<string, DietIcon> = {
  pescatarian: PescatarianIcon,
  spicy: SpicyIcon,
  vegan: VeganIcon,
  vegetarian: VegetarianIcon,
  chef_reco: ChefRecoIcon,
};

const dietTagLabels: Record<string, string> = {
  pescatarian: 'pescatarian',
  spicy: 'spicy',
  vegan: 'vegan',
  vegetarian: 'vegetarian',
  chef_reco: "chef's pick",
};

interface DietTagIconsProps {
  tags: string[] | undefined;
  chefRecommended?: boolean;
}

function DietTagIcon({ Icon, label }: { Icon: DietIcon; label: string }) {
  return (
    <Tooltip>
      <TooltipTrigger asChild>
        <span className="inline-flex">
          <Icon className="shrink-0 w-6 h-5" aria-label={label} aria-hidden={false} />
        </span>
      </TooltipTrigger>
      <TooltipContent variant="dark">{label}</TooltipContent>
    </Tooltip>
  );
}

export function DietTagIcons({ tags, chefRecommended }: DietTagIconsProps) {
  const hasIcons = (tags && tags.length > 0) || chefRecommended;
  if (!hasIcons) return null;

  return (
    <TooltipProvider delayDuration={200}>
      {tags?.map((tag) => {
        const Icon = dietTagIcons[tag];
        return Icon ? <DietTagIcon key={tag} Icon={Icon} label={dietTagLabels[tag]} /> : null;
      })}
      {chefRecommended && <DietTagIcon Icon={ChefRecoIcon} label={dietTagLabels['chef_reco']} />}
    </TooltipProvider>
  );
}
